export default {"cluster":"baseddb","org":"saulx","env":"production","project":"national-voting"};